document.addEventListener("DOMContentLoaded", () => {
    function onlyNumbersAndDelete(event) {
        var allowedKeys = [
            8, 46, 9, 27, 13, 37, 39, // Backspace, Delete, Tab, Escape, Enter, ArrowLeft, ArrowRight
            48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
            96, 97, 98, 99, 100, 101, 102, 103, 104, 105
        ];

        if ((event.ctrlKey || event.metaKey) && (event.key === "a" || event.key === "A")) {
            return;
        }

        var input = event.target;
        var maxLength = input.getAttribute("maxlength") ? parseInt(input.getAttribute("maxlength"), 10) : 6;

        if (!allowedKeys.includes(event.which || event.keyCode)) {
            event.preventDefault();
            return;
        }

        if (input.value.length >= maxLength && ![8, 46, 37, 39].includes(event.which || event.keyCode)) {
            event.preventDefault();
        }
    }

    const form = document.getElementById("step5");
    if (!form) return;

    const input = form.querySelector(".form__input_answer");
    const nextButton = form.querySelector(".btn-nav_next");
    const answerKey = "question_step5";

    input.addEventListener("keydown", onlyNumbersAndDelete);

    function checkInput() {
        const value = input.value.trim();
        if (value) {
            localStorage.setItem(answerKey, value);
            nextButton.classList.remove("btn_disabled");
        } else {
            localStorage.removeItem(answerKey);
            nextButton.classList.add("btn_disabled");
        }
    }

    const savedAnswer = localStorage.getItem(answerKey);
    if (savedAnswer) {
        input.value = savedAnswer;
        nextButton.classList.remove("btn_disabled");
    } else {
        nextButton.classList.add("btn_disabled");
    }

    input.addEventListener("input", checkInput);
});
